// Imports for external libraries go here.
import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { OffersTextBlockProps } from './OffersTextBlock.types';
import { StyledOffersTextBlock } from './OffersTextBlock.styles';

import { offerTextBlockMockData } from './__mock__/OffersTextBlock.mock';

import { TextComponent, size } from '@marriott/mi-ui-library';

export const OffersTextBlockonfig = {
  emptyLabel: 'OfferTextBlock',
  isEmpty: false,
  resourceType: `mi-aem-offers-spa/components/offerstextblock`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OffersTextBlock: React.FC<OffersTextBlockProps> = (props: any) => {
  const { model, isAuthorMode } = props;
  //Once we start receving API data post that we will update this comment
  const offersTextBlockProps = !isAuthorMode ? offerTextBlockMockData : offerTextBlockMockData;
  return (
    <EditableComponent config={OffersTextBlockonfig} {...props}>
      <StyledOffersTextBlock data-testid="offers-textblock" data-component-name="o-offers-textblock">
        <div className="offer-text-block">
          <TextComponent
            {...model}
            componentId={model?.componentId ?? offersTextBlockProps.componentId}
            descriptionText={offersTextBlockProps?.descriptionText}
            descriptionFontSize={size.extraSmall}
            styleclass="custom-text-block"
          />
        </div>
      </StyledOffersTextBlock>
    </EditableComponent>
  );
};
